import CPSelectorTreeBuilderObserver from './CPSelectorTreeBuilderObserver'
import TreeNodeSet from '../hierarchySelector/tree/TreeNodeSet'

export default class ReportsCPSelectorTreeBuilderObserver extends CPSelectorTreeBuilderObserver {
    constructor({
        searchIndex,
        allActiveSet,
        searchCustomers,
    }){
        super(searchIndex, allActiveSet, searchCustomers)
        this.projectsWithMaNodesSet = new TreeNodeSet()
        this.accessibleCustomerNodesSet = new TreeNodeSet()
    }

    projectNodeAdded(projectNode) {
        super.projectNodeAdded(projectNode)

        const project = projectNode.getValue()

        if (project.fromManagementScope) {
            this.projectsWithMaNodesSet.add(projectNode)
            this.accessibleCustomerNodesSet.add(projectNode.getParent())
        }
    }

    getProjectsWithMaNodesSet() {
        return this.projectsWithMaNodesSet
    }

    /**
     *
     * @returns {TreeNodeSet} of customers containing manageable projects
     */
    getAccessibleCustomerNodesSet() {
        return this.accessibleCustomerNodesSet
    }
}


// WEBPACK FOOTER //
// ./web/js/cp_selector/ReportsCPSelectorTreeBuilderObserver.js